import { DEVICE_DEPENDENT_CHARS } from '../constants/TextSanitizationConstants'

/**
 * Custom validation functions for formsy-semantic-ui-react
 * These functions follow the formsy validation pattern: (values, value) => boolean
 */

/**
 * Validates that value is not only whitespace characters
 * Includes both English spaces and Japanese full-width spaces
 * @param {*} values - Form values (required by formsy)
 * @param {string} value - Field value to validate
 * @returns {boolean} True if valid (not only whitespace)
 */
export const validateNotOnlyWhitespace = (values, value) => {
  if (!value) return true
  return !/^[\s\u3000]+$/.test(value)
}

/**
 * Validates that value does not contain device-dependent characters
 * Checks for environment-dependent chars but excludes special spaces
 * @param {*} values - Form values (required by formsy)
 * @param {string} value - Field value to validate
 * @returns {boolean} True if valid (no device-dependent chars found)
 */
export const validateNoDeviceDependentChars = (values, value) => {
  if (!value) return true

  // Create array of all device-dependent characters
  const deviceDepChars = Object.values(DEVICE_DEPENDENT_CHARS)
    .map(string => string.split(''))
    .flat()

  // Create regex pattern to check for any device-dependent character
  const deviceDepRegex = new RegExp(`[${deviceDepChars.join('')}]`, 'gmi')

  // Return true if no device-dependent chars found, false otherwise
  return !deviceDepRegex.test(value)
}
